import type { BeforeInstallPromptEvent } from '@/components/goat/layout/install/Prompt'
import { isFirefox, isOpera } from 'mobile-device-detect'
import {

  canInstallAsApp,
  deferredPrompt,
  supportedInstallAsApp
} from '@/components/goat/layout/install/Prompt'

const { isProd } = siteUtils // eg in opera BeforeInstallPromptEvent: prompt() method exist but not works;
let isTestMode = false
if (!isProd && !import.meta.env.SSR && window?.location?.search === '?testModeInstallPwa') {
  //  /game/soccer-clash?testModeInstallPwa
  isTestMode = true
}

if (!import.meta.env.SSR && window?.BeforeInstallPromptEvent && ((!isOpera && !isFirefox) || isTestMode)) {
  supportedInstallAsApp.value = true
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e as BeforeInstallPromptEvent
    canInstallAsApp.value = true
  })
}
